import { gql } from "@apollo/client";

const GET_COUNTRIES = gql`
  query countries {
    countries {
      ID
      CountryName
      CountryLink
      CountryISO
    }
  }
`;

export default GET_COUNTRIES;
